import { useRuntimeConfig } from 'nuxt/app';
let runtimeConfig: any = '';
if (process.client) {
	runtimeConfig = useRuntimeConfig();
}
export const getAssetsCurrencyFile = (url: string) => {
	if (process.client && url) {
		return `${runtimeConfig.public.nuxtBaseLinkPath}/static/img/currency/${url}.png`;
	}
};
export const getAssetsCarrierFile = (url: string) => {
	return `${runtimeConfig.public.nuxtBaseLinkPath}/static/img/logo/${url}.png`;
};

export const getAssetsHeaderFile = (url: string) => {
	return `${runtimeConfig.public.nuxtBaseLinkPath}/static/img/header/${url}.png`;
};
export const getAssetsHotDealFile = (url: string) => {
	return `${runtimeConfig.public.nuxtBaseLinkPath}/static/img/hotDeal/${url}`;
};
export const getAssetsTopDestinationFile = (url: string) => {
	return `${runtimeConfig.public.nuxtBaseLinkPath}/static/img/topDestination/${url}`;
};
